export default __webpack_public_path__ + "static/media/save-time.892735a9.svg";